import { render, staticRenderFns } from "./ViewPriorityZone.vue?vue&type=template&id=65d657b9&scoped=true"
import script from "./ViewPriorityZone.vue?vue&type=script&lang=js"
export * from "./ViewPriorityZone.vue?vue&type=script&lang=js"
import style0 from "./ViewPriorityZone.vue?vue&type=style&index=0&id=65d657b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d657b9",
  null
  
)

export default component.exports